import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {
    private itemsSource = new BehaviorSubject<MenuItem[]>([]);
    private items: MenuItem[] = [];

    itemsHandler = this.itemsSource.asObservable();

    /** Replaces all breadcrumbs with items */
    setItems(items: MenuItem[]) {
        this.items = items;
        this.itemsSource.next(items);
    }

    /** Add one or more items to the end of the breadcrumbs */
    push(...items: MenuItem[]) {
        this.items.push(...items);
        this.itemsSource.next(this.items.slice());
    }

    /** Remove one or more items from the end of the breadcrumbs */
    pop(count = 1) {
        while (count-- && this.items.length) {
            this.items.pop();
        }
        this.itemsSource.next(this.items.slice());
    }
}
